import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class EditProfileService {
    public openEditProfile = new Subject<any>();
    public openEmergencyContacts = new Subject<any>();
    constructor() {
    }
}
